/**
 * The address is stored in a nested object so the text and UPRN can both be managed by a single custom RJSF field
 * component. However, the server expects a flat model, so flatten it before submission.
 *
 * @param formData
 * @param schema
 * @param flatModel
 * @return {object}
 */
export const flattenFormData = (formData, schema, flatModel = {}) => {

  const fieldDefinitions = schema.properties;

  return Object.keys(formData).reduce((result, fieldKey) => {
    const fieldLabel = fieldDefinitions[fieldKey].title;
    const fieldValue = formData[fieldKey];

    if (typeof fieldValue === 'object') {
      flattenFormData(fieldValue, fieldDefinitions[fieldKey], result);

    } else if (!fieldLabel) {
      throw new Error(`No label found for field with key '${fieldKey}'`);

    } else if (result[fieldKey]) {
      throw new Error(`Duplicate key '${fieldKey}' detected during form data flattening`);

    } else {
      result[fieldKey] = {title: fieldLabel, value: fieldValue};
    }

    return result;
  }, flatModel);
};

/**
 * A side-effect free function that transforms the evidence data into the format expected by the server-side.
 *
 * @param formData the data entered into the form
 * @param schema the form's JSON schema
 * @param serviceArea
 * @param evidenceType
 */
export const evidenceDataTransformer = (formData, schema, serviceArea, evidenceType) => {

  const {images} = formData;
  const formFieldsClone = {...formData};
  delete formFieldsClone.images;

  const formFields = flattenFormData(formFieldsClone, schema);

  return {
    images,
    formFields,
    serviceArea: {
      id: serviceArea.id,
      title: serviceArea.label
    },
    evidenceType: {
      id: evidenceType.id,
      title: evidenceType.label,
      category: evidenceType.category
    }
  };
};
